export default "__VITE_ASSET__5634016e__"